import * as React from "react"

import {DIPBrand, DIPCountry, DIPSite, DIPSku} from "@components";
import {GROUPED_BY} from "@constants";
import {useRepricingFormData} from "../../@hooks";
import RepricingFormScopeStock from "./Stock";


const factorySelectValue = criterion => ({
	market: DIPCountry,
	[GROUPED_BY.RETAILER]: DIPSite,
	[GROUPED_BY.BRAND]: DIPBrand,
	[GROUPED_BY.SKU]: DIPSku,
	[GROUPED_BY.STOCK]: RepricingFormScopeStock
})[criterion]
const translateCriterionFilter = criterion => ({
	market: 'country',
	[GROUPED_BY.BRAND]: 'brand',
})[criterion]

export default function RepricingFormScopeValueSelects({ criterion, value }) {
	const { dataScope, handleChangeScopeValue } = useRepricingFormData(criterion)
	const isStock = criterion === GROUPED_BY.STOCK

	const filters = {}
	dataScope.forEach(item => {
		const translatorKey = translateCriterionFilter(item.key)
		if (translatorKey)
			filters[translatorKey] = item.value
	})

	const Component = factorySelectValue(criterion)
	if (!Component)
		return <></>

	return <Component
		multiple={!isStock}
		value={value}
		filters={filters}
		onChange={e => handleChangeScopeValue('value', e.target.value)}
	/>
}